import React from "react";
import { clients } from "../data/content";
export function LogoMarquee() {
  return <section className="border-y border-quiet py-12 md:py-14" aria-labelledby="trusted-heading" data-id="element-187" data-mp="2dxc9mrwe7862">
      <p id="trusted-heading" className="container-x mb-8 font-mono text-[12px] tracking-[0.12em] text-foot" data-id="element-188" data-mp="2iwx4or8fywdi">
        FROM THE STUDIO TRUSTED BY TEAMS AT
      </p>
      <div className="relative overflow-hidden" style={{
      maskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)"
    }} data-id="element-189" data-mp="2mw5y1uzkks8j">
        <div className="marquee flex w-max" data-id="element-190" data-mp="2wvwrrugb337k">
          {[0, 1].map(copy => <ul key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1} data-id="element-191" data-mp="31nevurdmljwr">
              {clients.map(name => <li key={`${copy}-${name}`} className="px-7 font-sans text-[20px] font-semibold tracking-[-0.02em] text-white/55 md:px-10 md:text-[22px]" data-id="element-192" data-mp="36l81njb0obwi">
                  {name}
                </li>)}
            </ul>)}
        </div>
      </div>
    </section>;
}